import React from 'react';

export default function ContentElementText(Element) {
  return (
    <div
      className="content-element-padding prose-sm md:prose dark:!text-foreground dark:prose-strong:text-foreground"
      dangerouslySetInnerHTML={{ __html: Element.text }}
    />
  );
}
